type PlainBoxProps = {
    fill: string;
    stroke?: string;
};

export function PlainBox(props: PlainBoxProps) {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 977 125"><g fill={props.fill} stroke={props.stroke}><path d="m374.05,69.69v.16s-2.74-.13-2.74-.13l2.74-.03ZM0,1.27l.69,19.81v33.5l23.69-2.98L1.46,59.08c0,1.04.83,7.49,1.62,8.29l.95,22.13-1.15,2.7,2,32.42,4.98.37,370.79-2.32.03.7v.35l595.56-8.78.77-7.86c0-1.06-.54-1.99-1.29-2.84l-1.2-34.34-75.23,2.6-79.12-1.35,148.9-4.81-.2-24.19h-1.03V3.52c0-1.06-.54-2-1.29-2.84l-.02-.68H370.81l.05,1.27H0Z" /></g></svg>;
}
